import { render, staticRenderFns } from "./UserBind.vue?vue&type=template&id=ab98e06e&scoped=true"
import script from "./UserBind.vue?vue&type=script&lang=js"
export * from "./UserBind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab98e06e",
  null
  
)

export default component.exports